import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import { hideRightBar } from '../../actions/rightBarActions'
import { getUrlWithVersion } from '../../../api/api'
import { fetchProductBackupSettings } from './fetchProductBackupSettings'
import { selectAllProductsSettings } from '../../selectors/settingsSelectors'

export const updateProductBackupSettings = createAsyncThunk<
    void,
    { guid: string; },
    ThunkConfig<string>
>('coreSettingsSlice/updateProductBackupSettings', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
        getState
    } = thunkAPI
    const { guid } = args
    const allProductsSettings= selectAllProductsSettings(getState())
    const data = allProductsSettings[guid]?.backupSettings

    try {
        await api.put(
            getUrlWithVersion(`/products/${guid}/core_settings/backup`),
            data
        )

        throwSuccessMessage('Backup settings successfully updated')
        dispatch(fetchProductBackupSettings({ guid }))
        dispatch(hideRightBar())
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Backup settings update failed')
    }
})
